import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=1c1ca022"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=1c1ca022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports